import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  to?: string;
  linkLabel?: string;
  icon?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  to,
  linkLabel = "查看全部",
  icon = "ri-layout-grid-line",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
          <i className={`${icon} text-xl`}></i>
        </span>
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            {title}
          </h2>
          {subtitle && <p className="mt-0.5 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {to && (
        <Link
          to={to}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-600 transition-colors hover:text-accent-700"
        >
          {linkLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}